import type { IconName } from "@msuite/ui/icons";
import type { TranslationKey } from "@msuite/utils/locales";

export type CapacityResourceCategoryValue = "crews";

export interface CapacityResourceCategory {
	value: CapacityResourceCategoryValue;
	labelKey: TranslationKey;
	iconName: IconName;
}

export type CapacityResourceCategoryList = Array<CapacityResourceCategory>;

/**
 * The resource categories capacity planning works in. Crews are the only one planned against, so
 * the list holds one entry and the panel's control offers one segment. The resources panel takes
 * its segments from here and the capacity-planner board its sections, so a further category
 * reaches both by being added here and to the value union above.
 */
export const CAPACITY_RESOURCE_CATEGORIES: CapacityResourceCategoryList = [
	{ value: "crews", labelKey: "planning.crews.crews_title", iconName: "Users" },
];
